import Select from "../../../components/common/controls/Select";
import { ContactRequestStatus } from "../../../shared/enums/ContactRequestStatusEnum";
import { GetEnumKeyValues } from "../../../shared/utility/CommonUtility";

interface Props {
  onFilterChange: (selectedOption: any) => void;
} 

export default function ContactSalesGridFilter(props: Props) {
  const { onFilterChange } = props;
  const ContactRequestStatusValues = GetEnumKeyValues(ContactRequestStatus);

  const options = [
    ...ContactRequestStatusValues.map((keyVal: { key: string; value: number }) => ({
      value: keyVal.value,
      display: keyVal.key,
    })),
  ];

  const handleFilterChange = (filterValue: any) => {
    onFilterChange(filterValue);
  };

  return (
    <div className="flex items-center">
      <span className="font-bold mr-2">view:</span>
      <Select
        items={options}
        onValueChange={handleFilterChange}
        className="w-48"
        defaultValue={ContactRequestStatus.Received}
        displayExpr="display"
        valueExpr="value"
      />
    </div>
  );
}